import React from 'react';

export default function SectionLabel({ children, right }) {
  return (
    <div className="portal-section-label">
      <span>{children}</span>
      {right != null && <span className="portal-section-right">{right}</span>}
    </div>
  );
}
